// Remark plugin that annotates math/inlineMath MDAST nodes with HAST conversion data for remark-rehype.
export function remarkMathToHast() {
	return (tree: any) => {
		const visit = (node: any) => {
			if (!node || typeof node !== 'object') return;
			// Map block math to <pre className="math-display">
			if (node.type === 'math') {
				node.data = {
					hName: 'pre',
					hProperties: { className: ['math-display'] },
					hChildren: [{ type: 'text', value: node.value }],
				};
			}
			// Map inline math to <code className="math-inline">
			if (node.type === 'inlineMath') {
				node.data = {
					hName: 'code',
					hProperties: { className: ['math-inline'] },
					hChildren: [{ type: 'text', value: node.value }],
				};
			}
			if (Array.isArray(node.children)) node.children.forEach(visit);
		};
		visit(tree);
	};
}
